import { Select } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import StandingList from "~pages/Standings/components/StandingList";
import StandingsDivision from "~pages/Standings/components/StandingsDivision";
import { GroupingConferenceDivision } from "~pages/Standings/enums/groupingConferenceDivision";
import type { StandingTransformed } from "~pages/Standings/types/standingTransformed";
import type { TransformedResult } from "~pages/Standings/types/transformedResult";

type Props = {
  conferences: Array<TransformedResult<StandingTransformed | TransformedResult<StandingTransformed>>> | undefined;
  grouping: GroupingConferenceDivision;
  selectedColumns: string[];
};

const StandingsConference = ({ conferences, grouping, selectedColumns }: Props) => {
  const options = conferences?.map((item) => ({
    label: item.entity?.name || "",
    value: item.entity?.id || "",
  }));
  const [current, setCurrent] = useState<string | undefined>(options?.[0]?.value);

  if (!options) {
    return null;
  }

  const data = conferences?.find((st) => st.entity?.id === current)?.values || [];

  return (
    <>
      {(grouping === GroupingConferenceDivision.Division || grouping === GroupingConferenceDivision.Conference) && options.length > 0 && (
        <span style={{ order: 1 }}>
          <FormattedMessage id={"conference"} />:
          <Select value={current} onSelect={setCurrent} style={{ width: 200, marginLeft: 10 }} options={options} />
        </span>
      )}
      <span style={{ flexBasis: "100%", order: 4, width: "100%" }}>
        {current && current !== "nonConferencesStandings" && (
          <>
            {grouping === GroupingConferenceDivision.Division && (
              <span>
                <StandingsDivision selectedColumns={selectedColumns} divisions={data as Array<TransformedResult<StandingTransformed>>} />
              </span>
            )}
            {grouping === GroupingConferenceDivision.Conference && (
              <StandingList selectedColumns={selectedColumns} data={data as Array<StandingTransformed>} />
            )}
          </>
        )}
        {(!current || current === "noKeyData") && (
          <StandingList selectedColumns={selectedColumns} data={data as Array<StandingTransformed>} />
        )}
      </span>
    </>
  );
};

export default StandingsConference;
